import bsEnConfig from './BsEn/Config';

export default {
  ...bsEnConfig,
};
